import React, {useEffect, useState} from "react";
import classnames from 'classnames/bind';
import styles from 'componets/fix-top-container/index.module.scss';

const cx = classnames.bind(styles);

const FixTopContainer = (props) => {

  const [state, setState] = useState({
    move: false,
    hide: false
  });

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll)
    };
  },[]);

  const handleScroll = () => {
    if (document.documentElement.scrollTop > 15 || document.body.scrollTop > 15) {
      setState({
        move: true,
        hide: true,
      });
    } else {
      setState({
        move: false,
        hide: false,
      });
    }
  };

  const classNames = cx({
    container: true,
    move: state.move,
    hide: state.hide
  });

  return (
    <div className={classNames}>
      {props.children}
    </div>
  );
};

export default FixTopContainer
